import { render, staticRenderFns } from "./JfPay.vue?vue&type=template&id=0bb7348b&scoped=true&"
import script from "./JfPay.vue?vue&type=script&lang=js&"
export * from "./JfPay.vue?vue&type=script&lang=js&"
import style0 from "./JfPay.vue?vue&type=style&index=0&id=0bb7348b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb7348b",
  null
  
)

export default component.exports